<template>
  <div class="mrgt- lastKnownLocation">
    {{
      $t('users.statuses.last-known-localisation', { localisationTimeFromNow })
    }}
  </div>
</template>

<script>
import moment from 'moment';
moment.locale('fr');

export default {
  components: {},

  props: {
    heartbeat: {
      type: Object,
      required: true,
    },
  },

  computed: {
    localisationTimeFromNow() {
      return moment(this.heartbeat.timestamp).fromNow();
    },
  },

  methods: {},
};
</script>
